import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/routes';
import { LoadingSpinner } from '@/components/LoadingSpinner';

export function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to={ROUTES.DASHBOARD_STORY_TEMPLATES} replace />;
  }

  return <>{children}</>;
}
